import _regeneratorRuntime from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/regenerator";
import _defineProperty from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _asyncToGenerator from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { chainData, chains } from '@jdiyield/constants';
import Web3 from 'web3';
import getNodeUrl from './rpcRandom';
export var setupNetwork = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(chainID) {
    var provider, _chainData$chainID, dexguruID, _chainID, rest, web3, currentChainId;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            provider = window.ethereum;

            if (!provider) {
              _context.next = 26;
              break;
            }

            _context.prev = 2;
            _chainData$chainID = chainData[chainID], dexguruID = _chainData$chainID.dexguruID, _chainID = _chainData$chainID.chainID, rest = _objectWithoutProperties(_chainData$chainID, ["dexguruID", "chainID"]);

            if (!(chainID !== 1)) {
              _context.next = 9;
              break;
            }

            _context.next = 7;
            return provider.request({
              method: 'wallet_addEthereumChain',
              params: [_objectSpread(_objectSpread({}, rest), {}, {
                chainId: "0x".concat((+chainID).toString(16)),
                rpcUrls: [getNodeUrl(chainID)]
              })]
            });

          case 7:
            _context.next = 11;
            break;

          case 9:
            _context.next = 11;
            return provider.request({
              method: 'wallet_switchEthereumChain',
              params: [{
                chainId: "0x".concat((+chainID).toString(16))
              }]
            });

          case 11:
            web3 = new Web3(provider);
            _context.next = 14;
            return web3.eth.net.getId();

          case 14:
            currentChainId = _context.sent;

            if (!(currentChainId !== chainID)) {
              _context.next = 17;
              break;
            }

            return _context.abrupt("return", false);

          case 17:
            return _context.abrupt("return", true);

          case 20:
            _context.prev = 20;
            _context.t0 = _context["catch"](2);
            console.error(_context.t0);
            return _context.abrupt("return", false);

          case 24:
            _context.next = 28;
            break;

          case 26:
            console.error("Can't setup the BSC network on metamask because window.ethereum is undefined");
            return _context.abrupt("return", false);

          case 28:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 20]]);
  }));

  return function setupNetwork(_x) {
    return _ref.apply(this, arguments);
  };
}();
export var checkSwitchChain = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(currentChainId, gotoChain) {
    var currentChain, chainId;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            currentChain = chainData[currentChainId];

            if (!(gotoChain !== (currentChain === null || currentChain === void 0 ? void 0 : currentChain.chainName))) {
              _context2.next = 6;
              break;
            }

            chainId = chains[gotoChain === null || gotoChain === void 0 ? void 0 : gotoChain.toLowerCase()];
            _context2.next = 5;
            return setupNetwork(chainId);

          case 5:
            return _context2.abrupt("return", _context2.sent);

          case 6:
            return _context2.abrupt("return", true);

          case 7:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function checkSwitchChain(_x2, _x3) {
    return _ref2.apply(this, arguments);
  };
}();